<template lang="pug">
article.c-staffs-section.section
  .container
    .title {{ title }}
    template(v-if="data")
      staff-list(:title="title"
        :items="data.items")
</template>

<script>
import StaffList from "@/components/StaffList.vue";

export default {
  name: "StaffsSection",
  components: {
    StaffList
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      data: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const doc = await this.$f.db
        .collection("staffs")
        .doc(this.id)
        .get();
      this.data = this.$u.parseDbSnap(doc);
    }
  }
};
</script>
